import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { MarginProps } from 'styled-system';

import { Flex, Margin } from 'src/packages/core';
import { SelectDropdownProps } from './SelectDropdown.types';

export const OptionWrapper = styled((props) => <Flex {...props} />)`
  ${({ theme: { colors } }) => `
    padding: 8px 12px;
    gap: 8px;
    align-items: center;
    
    .label{
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
    }
    
    &:hover{
      background: ${colors.background.secondary.BG4};
    }
  `}
`;

export const SelectWrapper = styled(
  React.forwardRef<HTMLDivElement, any>((props, ref) => <Margin {...props} ref={ref} />)
)<
  Pick<SelectDropdownProps, 'width' | 'variant' | 'transparent'> &
    MarginProps & { defaulttheme: DefaultTheme }
>`
  width: ${(props) => props.width};
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  position: relative;

  .basic-single,
  .basic-multi-select,
  .select__menu-portal {
    cursor: pointer;
    box-shadow: none;
    position: relative;
    direction: ltr;

    * {
      outline: none;
      cursor: pointer;
    }

    .select__control {
      height: ${(props) => (props.variant === 'secondary' ? '40px' : '48px')};
      border-width: 1px;
      border-style: solid;
      border-radius: 6px;
      border-color: ${({ defaulttheme }) => defaulttheme.colors.border.middle} !important;
      box-shadow: none;
      background-color: transparent;

      &:hover {
        border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary} !important;
      }

      svg {
        > path[stroke] {
          stroke: ${({ defaulttheme }) => defaulttheme.colors.text.secondary} !important;
        }

        > path[fill] {
          fill: ${({ defaulttheme }) => defaulttheme.colors.text.secondary} !important;
        }

        path {
          color: ${({ defaulttheme }) => defaulttheme.colors.text.secondary} !important;
        }
      }

      &.select__control--is-disabled {
        background-color: ${({ defaulttheme }) =>
          defaulttheme.colors.background.secondary.BG1} !important;
        border-color: ${({ defaulttheme }) =>
          defaulttheme.colors.background.secondary.BG1} !important;

        .select__single-value {
          color: ${({ theme }) => theme.colors.text.disabled} !important;
        }
      }

      svg {
        fill: ${({ defaulttheme }) => defaulttheme.colors.text.primary};
      }

      &--menu-is-open {
        border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary} !important;
        .select__dropdown-indicator {
          transform: rotate(180deg);
        }
      }
    }

    .select__indicator-separator {
      display: none;
    }

    .select__single-value {
      unicode-bidi: bidi-override;
      color: ${({ defaulttheme }) => defaulttheme.colors.text.primary};

      > div {
        unicode-bidi: bidi-override;
      }
    }

    .select__option {
      background-color: ${({ defaulttheme }) => defaulttheme.colors.background.secondary.BG1};
      color: ${({ defaulttheme }) => defaulttheme.colors.text.primary};

      &-is-selected,
      &--is-focused {
        background-color: ${({ defaulttheme }) => defaulttheme.colors.background.secondary.BG1};
        color: ${({ defaulttheme }) => defaulttheme.colors.text.primary} !important;
      }
    }
  }
`;
